import { createSlice } from '@reduxjs/toolkit';
import { emptyFetchState } from '../emptyState';
import { fetchStatus } from '../status';
import { getPublisherRevenue } from 'api';

// Then, handle actions in your reducers:
const publisherRevenueSlice = createSlice({
  name: 'publisherRevenue',
  emptyFetchState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    publisherRevenueFetchStart: (state) => {
      state.status = fetchStatus.FETCH_START;
      state.fetching = true;
    },
    publisherRevenueFetchSuccess: (state, { payload }) => {
      state.status = fetchStatus.FETCH_SUCCESS;
      state.payload = payload;
      state.fetching = false;
    },
    publisherRevenueFetchFail: (state, { payload }) => {
      state.status = fetchStatus.FETCH_FAIL;
      state.payload = payload;
      state.fetching = false;
      state.error = true;
    },
    publisherRevenueResetState: (state) => {
      state.status = null;
      state.payload = null;
      state.fetching = false;
    },
  },
});

// actions generated from the slice, TODO: remove start,success,fail
export const {
  publisherRevenueFetchStart,
  publisherRevenueFetchSuccess,
  publisherRevenueFetchFail,
  publisherRevenueResetState,
} = publisherRevenueSlice.actions;

// The reducer
export const publisherRevenueReducer = publisherRevenueSlice.reducer;

// Asynchronous thunk action
export const publisherRevenueFetch = (id: string) => (dispatch) => {
  dispatch(publisherRevenueFetchStart());

  getPublisherRevenue(id)
    .then((publisherRevenue) => {
      dispatch(publisherRevenueFetchSuccess(publisherRevenue.data));
    })
    .catch((error) => {
      dispatch(publisherRevenueFetchFail(error));
    });
};
